import { Typography } from "@mui/material";
import React from "react";
import "./projectHeader.scss";
import "../../css/utility.scss";

export default function ProjectHeader(props) {
  const { text, position } = props;
  return (
    <div
      className="p-header"
      style={{
        justifyContent: position,
      }}
    >
      <Typography className="project-title" variant="h6">
        {text}
      </Typography>
    </div>
  );
}
